import http from '~/common/http'export default {    /**     * 首页列表     * @param params     * @returns {AxiosPromise<any>}     */    getList(params) {        return http.get('/api/home/index', {            params: params        });    },}


// WEBPACK FOOTER //
// ./src/services/home.js